/**
 * Very basic ordering param class
 * TODO Support multiple order by clauses. Maintain an array and allow 
 * manipulation as necessary
 */
export class OrderParams {
  orderBy: string = 'id';
  order: 'asc' | 'desc' = 'desc';
}